export const USER = 'USER';
export const LOADING = 'LOADING';
export const SHOPPING = 'SHOPPING';
export const LICENSE = 'LICENSE';
export const NOTIFICATIONS = 'NOTIFICATIONS';
